import React from 'react';
import Page from '../components/Page';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from 'reactstrap';
import classnames from 'classnames';
import CompensationForm from '../components/CompensationForm';
import loader from '../assets/img/loader.gif';

class CompensationPage extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
      hidden: false,
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  toggleModal = modalType => () => {
    if (!modalType) {
      return this.setState({
        modal: !this.state.modal,
      });
    }

    this.setState({
      [`modal_${modalType}`]: !this.state[`modal_${modalType}`],
    });
  };
  render() {
    const { activeTab, hidden } = this.state;
    return (
      <Page
        className="CompensationPage"
        title="Compensation"
        breadcrumbs={[{ name: 'Compensation', active: true }]}
      >
        <div className={'ps-loader ' + (hidden ? '' : 'hidden')}>
          <img
            src={loader}
            style={{ width: 50, height: 50, position: 'relative' }}
            alt="logo"
          />
        </div>
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '1' })}
                      onClick={() => {
                        this.toggle('1');
                      }}
                    >
                      Salary Range
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '2' })}
                      onClick={() => {
                        this.toggle('2');
                      }}
                    >
                      Allowance
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '3' })}
                      onClick={() => {
                        this.toggle('3');
                      }}
                    >
                      Short Term Incentive
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '4' })}
                      onClick={() => {
                        this.toggle('4');
                      }}
                    >
                      Long Term Incentive
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '5' })}
                      onClick={() => {
                        this.toggle('5');
                      }}
                    >
                      Sign On
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '6' })}
                      onClick={() => {
                        this.toggle('6');
                      }}
                    >
                      Other Components
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1" className="py-3">
                    <Row>
                      <Col sm={12}>
                        <div className="text-right mb-4">
                          <Button
                            className="theme-button theme-button-primary"
                            onClick={this.toggleModal()}
                          >
                            Add
                          </Button>
                        </div>
                        <div className="tab-pane-content">
                          <Table responsive hover className="ps-table tb-col-8">
                            <thead>
                              <tr>
                                <th>Job Grade</th>
                                <th>Job Grade Type</th>
                                <th>Currency</th>
                                <th>Salary Range Min</th>
                                <th>Salary Range Mid</th>
                                <th>Salary Range Max</th>
                                <th>Country</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Jacob</td>
                                <td>Thornton</td>
                                <td>@fat</td>
                                <td>Otto</td>
                                <td>Otto</td>
                                <td>Otto</td>
                                <td>Otto</td>
                                <td>
                                  <div className="ps-action-button">
                                    <Button
                                      className="theme-button theme-button-primary-light"
                                      onClick={this.toggleModal()}
                                    >
                                      Edit
                                    </Button>
                                    <Button className="theme-button theme-button-secondary">
                                      Delete
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="2" className="py-3">
                    <Row>
                      <Col sm={12}>
                        <div className="tab-pane-content">
                          <Table responsive hover className="ps-table tb-col-5">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Country</th>
                                <th>Type</th>
                                <th>Industry</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Jacob</td>
                                <td>Thornton</td>
                                <td>@fat</td>
                                <td>Otto</td>
                                <td></td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="3">
                    <Row>
                      <Col sm={12}>
                        <div className="tab-pane-content"></div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="4">
                    <Row>
                      <Col sm={12}>
                        <div className="tab-pane-content"></div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="5">
                    <Row>
                      <Col sm={12}>
                        <div className="tab-pane-content"></div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="6">
                    <Row>
                      <Col sm={12}>
                        <div className="tab-pane-content"></div>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
                <Modal
                  isOpen={this.state.modal}
                  toggle={this.toggleModal()}
                  className={this.props.className}
                  centered
                >
                  <ModalHeader toggle={this.toggleModal()}>
                    Invite User
                  </ModalHeader>
                  <ModalBody>
                    <CompensationForm history={this.props.history} />
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      className="theme-button theme-button-secondary"
                      onClick={this.toggleModal()}
                    >
                      Close
                    </Button>
                    <Button
                      className="theme-button theme-button-primary"
                      onClick={this.toggleModal()}
                    >
                      Invite
                    </Button>{' '}
                  </ModalFooter>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
    );
  }
}
export default CompensationPage;
